<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content"
        v-loading="loadingStaus"
        :element-loading-text="loadingText">
        <el-row :gutter="48">
          <el-form ref="companyForm" :model="formData" :rules="rules" label-width="110px">
            <el-col :span="16" class="content-left">
              <el-form-item label="父级分类" prop="selectedList" ref="categoryItem">
                <el-select v-model="formData.parent_id" @change="categoryChange" filterable placeholder="请选择公司">
                  <el-option
                    v-for="item in categoryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开放平台配置" prop="openapi_id">
                <el-select v-model="formData.openapi_id" @change="openapiChange" filterable placeholder="请选择开放平台配置">
                  <el-option
                    v-for="item in openapiList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="公司名称" prop="name">
                <el-input v-model="formData.name"></el-input>
              </el-form-item>
              <el-form-item label="纳税人识别号" prop="taxpayer">
                <el-input v-model="formData.taxpayer"></el-input>
              </el-form-item>
               <el-form-item label="公司简介" prop="remark">
                <el-input type="textarea" v-model="formData.remark"></el-input>
              </el-form-item>
              <el-form-item label="公司账号" prop="account">
                <el-input v-model="formData.account"></el-input>
              </el-form-item>
              <el-form-item label="公司法人" prop="legal_person">
                <el-input v-model="formData.legal_person"></el-input>
              </el-form-item>
              <el-form-item label="法人联系号码" prop="legal_phone">
                <el-input v-model="formData.legal_phone"></el-input>
              </el-form-item>
              <el-form-item label="服务渠道" prop="channe_id">
                <el-input v-model="formData.channe_id"></el-input>
              </el-form-item>
              <el-form-item label="开户银行" prop="bank">
                <el-input v-model="formData.bank"></el-input>
              </el-form-item>
              <el-form-item label="开户名" prop="bank_name">
                <el-input v-model="formData.bank_name"></el-input>
              </el-form-item>
              <el-form-item label="企业地址" prop="address">
                <el-input v-model="formData.address"></el-input>
              </el-form-item>
              <el-form-item label="收件地址" prop="email">
                <el-input v-model="formData.email"></el-input>
              </el-form-item>
              <el-form-item label="收件人" prop="receiver_fullname">
                <el-input v-model="formData.receiver_fullname"></el-input>
              </el-form-item>
              <el-form-item label="收件人电话" prop="receiver_phone">
                <el-input v-model="formData.receiver_phone"></el-input>
              </el-form-item>
              <el-form-item label="企业电话" prop="company_phone">
                <el-input v-model="formData.company_phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="content-right" :span="6">
              <!-- <el-form-item label="附件" prop="attachment">
                <ApeUploader :limit="1" :isImage="false" :allowSize="1024*1024*500" :allowTypeList="attachmentType" @handleUploadSuccess="handleAttachmentUploadSuccess" @handleUploadRemove="handleAttachmentUploadRemove" :upload-file-list="attachmentUploadFileList"></ApeUploader>
              </el-form-item> -->
              <el-form-item label="签约类型" prop="sign_type" size="small">
                <el-select v-model="formData.sign_type" filterable placeholder="请选择签约类型">
                  <el-option
                    v-for="item in signTypeList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签约服务类型" prop="status" size="small">
                <el-select v-model="formData.category" multiple filterable placeholder="请选择签约服务类型">
                  <el-option
                    v-for="item in enumList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态" prop="status" size="small" style="min-width: 360px">
                <el-radio-group v-model="formData.status">
                  <el-radio-button label="0">待审核</el-radio-button>
                  <el-radio-button label="1">审核已通过</el-radio-button>
                  <el-radio-button label="2">审核不通过</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="签章签约状态" prop="sign_status " size="small">
                <el-switch
                  v-model="formData.sign_status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                  >
                </el-switch>
              </el-form-item> -->
              <el-form-item label="到账短信提醒" prop="is_open_sms " size="small">
                <el-switch
                  v-model="formData.is_open_sms "
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                  @change="openSms"
                  >
                </el-switch>
              </el-form-item>
               <el-form-item label="支持批量导入" prop="is_import" size="small">
                <el-switch
                  v-model="formData.is_import "
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="2"
                  @change="openImport"
                  >
                </el-switch>
              </el-form-item>
              <div class="right-button">
                <el-button size="medium" type="primary"  :disabled="formDisabled" @click="saveConfirm">保存</el-button>
                <el-button size="medium" @click="returnList">返回</el-button>
              </div>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="smsForm" ref="form" label-width="80px">
          <el-form-item label="模版">
            <el-radio-group v-model="smsForm.template_id" @change="selectRadio">
              <el-radio v-for="(item, index) in smsData" :key="index" :label="item.template_id">{{item.desc}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="smsForm.template_desc" placeholder="请输入描述信息"></el-input>
          </el-form-item>
          <el-form-item label="平台名">
            <el-input v-model="smsForm.sms_alias_name" placeholder="请输入平台名"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div >
</template>

<script>
import ModalDialog from "@/components/ModalDialog";
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeUploader from '@/components/ApeUploader'
import ApeEditor from '@/components/ApeEditor'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeUploader,
    ApeEditor,
    ModalDialog
  },
  data() {
    return {
      smsForm: {
        template_id: '',
        template_desc: '',
        sms_alias_name: ''
      },
      dialogData:{
        visible: false,
        title: '短信模版',
        width: '45%',
        loading: true,
        modal: false
      },
      smsData: '',
      activeTab: '0',
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '正在提交中……',
      formDisabled: false,
      companyId:0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      // 分类列表
      categoryList:[],
      openapiList:[],
      enumList:[],
      signTypeList: [
        {
          value: 'def',
          label: '默认'
        },
        {
          value: 'esign',
          label: 'e签宝'
        },
        {
          value: 'fsign',
          label: '放心签'
        }
      ],
      // 标签
      categoryLabelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已选中标签
      selectedLabelList:[],
      // 公司基本信息表单结构
      formData:{
        status: 1,
        sign_type: 'def'
      },
      // 已上传图片列表
      uploadFileList:[],
      // 公司基本信息规则
      rules: {
        name: [
          {required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        taxpayer: [
          {required: true, message: '请输入纳税人识别', trigger: 'blur' },
        ]
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
  },
  methods: {
    //获取短信模版数据
    async getSmsTemplate() {
      let result = await this.$api.getSmsTemplate()
      if(result) {
        this.smsData = result
        this.dialogData.visible = true
      }
    },
    //短信开关
    openSms() {
      if(this.formData.is_open_sms == 1) {
        this.formData.is_open_sms = 0
        this.getSmsTemplate()
      }
      if(this.formData.is_open_sms == 0) {
        this.formData.is_open_sms = 0
      }
    },
    //支持批量人才导入开关
    openImport() {
      if(this.formData.is_import == 1) {
        this.formData.is_import = 1
      }
      if(this.formData.is_import == 0) {
        this.formData.is_import = 2
      }
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(this.formData.is_open_sms == 1) {
            this.formData.is_open_sms = 0
          }
          if(this.formData.is_open_sms == 0) {
            this.formData.is_open_sms = 1
          }
          this.formData.template_desc = this.smsForm.template_desc
          this.formData.sms_alias_name = this.smsForm.sms_alias_name
          this.dialogData.visible = false
          this.smsForm = {}
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.smsForm = {}
      this.dialogData.visible = false
    },

    //单选操作
    selectRadio() {
      if(this.smsForm.template_id) {
        console.log(this.smsForm.template_id,"this.smsForm.template_id")
        this.dialogData.loading = false
        this.formData.template_id = this.smsForm.template_id
      }
    },
    // 返回列表
    returnList() {
      this.$router.push('/company')
    },
    // 菜单选择
    categoryChange(v) {
      console.log("categoryChange", v)
      if (v) {
        this.formData.parent_id = v
      }
    },
    openapiChange(v) {
      console.log("openapiChange", v)
      if (v) {
        this.formData.openapi_id = v
      }
    },
    // 级联菜单组件change事件
    cascaderLabelChange(v) {
      if (v.length) {
        this.formData.category_2_id = v[(v.length-1)]
        this.formData.category_2_ids = v
      } else {
         this.formData.category_2_id = ''
         this.formData.category_2_ids = []
      }
    },
    // 级联菜单自定义验证，选择分类
    cascaderVerify(rule, value, callback) {
      if (rule.required && !this.selectedList.length) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 公司相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true
      console.log("formData -> ", this.formData);
      let id = await this.$api.saveCompany(this.formData)
      if (id) {
        this.$notify.success('保存成功！')
      }

      if (this.companyId === 0 && id) {
        // this.$router.push(this.$route.matched[1].path+'/'+id+'/edit')
        this.$router.push(this.$route.matched[1].path)
        // this.initcompanyForm()
      }
      this.$nextTick(() => {
        this.loadingStaus = false
      })
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.cover = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.cover = 0
      this.uploadFileList = fileList
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment = file.id
      this.attachmentUploadFileList = fileList
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment = 0
      this.attachmentUploadFileList = fileList
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.formData.cover) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.content = val
    },
    // 初始化公司基本信息
    async initCompanyForm() {
      // 获取公司分类列表
      this.categoryList = await this.$api.getCompanyCategoryList()
      this.openapiList = await this.$api.getOpenapiCategoryList()
      this.enumList = await this.$api.getCategoryEnumList('task')

      let url = this.$route.path
      let urlSlashCount=url.split('/').length
      this.action = url.split('/')[urlSlashCount-1].toLowerCase()
      this.formDisabled = (this.action === 'view') ? true : false
      console.log("action -> ", this.formDisabled)
      if (this.$route.params.company_id) {
        this.companyId = this.$route.params.company_id
      }
      if (this.companyId) {
        let {info} = await this.$api.getCompanyInfo(this.companyId)
        this.formData = info
        if(info.is_open_sms == 1) {
          this.formData.is_open_sms = 1
        }
        if(info.is_open_sms == 0) {
          this.formData.is_open_sms = 0
        }
      }
    },
  },
  async mounted() {
    this.loadingStaus = true
    this.initCompanyForm()
    this.$nextTick(() => {
      this.loadingStaus = false
    })
  },
}
</script>

<style lang="stylus" scoped>
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .content-right
    min-width 400px
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
    .right-button button
      margin-right 5px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
    /deep/.el-form-item--small .el-form-item__label
      line-height:40px
</style>
